import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import momentTz from 'moment-timezone';
import { IExpert } from '../../../../shared/models/expert.interface';

@Pipe({
  name: 'approvalTooltip',
  standalone: false,
})
export class ApprovalTooltipPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}
  // Note: no 12 vs 24 clock handling found here
  transform(
    clientApproved?: IExpert['clientApproved'],
    timezone?: string
  ): string {
    if (!clientApproved) {
      return 'Expert approval required';
    }

    const offset = timezone
      ? momentTz(clientApproved.dateCreated).tz(timezone).format('Z')
      : '';

    const dateString = this.datePipe.transform(
      clientApproved.dateCreated,
      'medium',
      offset
    );

    if (!clientApproved.firstName && !clientApproved.lastName) {
      return `Approved on ${dateString}`;
    }

    return `Approved by ${clientApproved.firstName} ${clientApproved.lastName} on ${dateString}`;
  }
}
